export interface CustomFieldsState {
	areaCustomFields: CustomFieldDto[],
	contactCustomFields: CustomFieldDto[],
	alarmCustomFields: CustomFieldDto[],
	serverCustomFields: CustomFieldDto[],
	deviceCustomFields: CustomFieldDto[],
	notificationTemplateCustomFields: CustomFieldDto[],
	totalAreaCustomFields: number,
	totalContactCustomFields: number,
	totalAlarmCustomFields: number,
	totalServerCustomFields: number,
	totalDeviceCustomFields: number,
	totalNotificationTemplateCustomFields: number
}

export interface CustomFieldValues {
	id: string;
	value: any;
}

export interface CustomFieldPriorityValue {
	id: string;
	value: any;
	title: string;
}

export interface CustomFieldValueAndSettings{
	value: CustomFieldValues,
	setting: CustomFieldDto
}

export interface CustomField {
	id: string;
	customFieldTableTypeId: number;
	customFieldTypeId: number;
	title: string;
	required: boolean;
	placeholder: string;
	order: number;
	options: CustomFieldOptions;
	externalIds?: string[];
}

export interface CustomFieldDto extends CustomField {
}

export interface CustomFieldForDisplay extends CustomField {
	customFieldType: string;
}

export interface CustomFieldToggleCollapseState {
	id: number;
	isOpen: boolean;
}

export interface CustomFieldOptions {
	data?: string[];
	allowMultiple?: boolean;
}

export enum CustomFieldTableTypes {
	Area = 1,
	Contact = 2,
	Alarm = 3,
	Server = 4,
	Device = 5,
	NotificationTemplate = 6,
}

export enum CustomFieldTypes {
	Text = 1,
	TextArea = 2,
	Number = 3,
	Checkbox = 4,
	Hyperlink = 5,
	Date = 6,
	Icon = 7,
	List = 8,
}
